__turbopack_context__.v({
  "hint": "ProfileCollaborateInput-module-scss-module__2VSc1W__hint",
  "label": "ProfileCollaborateInput-module-scss-module__2VSc1W__label",
  "root": "ProfileCollaborateInput-module-scss-module__2VSc1W__root",
});
